<template>
  <div class="featured-events">
    <grid
      v-if="!!events.records"
      :data="events.records" />
  </div>
</template>

<script>
import { getConfig } from "../utils/index.js";
import Grid from "./views/grid.vue";
import axios from 'axios'
let jsonpAdapter = require('axios-jsonp');

let sComponents = { Grid };

export default {
  name: "Featured",
  components: sComponents,
  data: function() {
    return {
      events: {}
    };
  },
  mounted: function(){
    this.getEvents()
  },
  methods: {
    getEvents: function(){
      const vm = this
      const e = axios({
        url: getConfig("events"),
        adapter: jsonpAdapter,
        params: Object.assign({}, { featured: 1, limit: 4 })
      }).then(({ data }) => {
        vm.events = Object.assign(data)
      }).catch(({}) => {})
    }
  }
};
</script>
<style lang="scss" >
.featured-events {
  color: #63594e;
  font-family: "proxima-nova",sans-serif;
  font-weight: regular;
  h3{
    font-family: "quincy-cf",serif;
    font-weight: bold;
    font-size: 1.65rem;
    color: #63594e;
  }
  a{
    color: #63594e;
  }
  a.button{
    border-radius: 4px;
  }
  a h3{
    color: #b77e46;
  }
  .row{

    .columns{
      padding-top: 1rem;
      padding-bottom: 1rem;
      padding-left: 1.5rem;
      padding-right: 1.5rem;
    }
    // If Larger than Mobile
    @media screen and (min-width: 40em){
      padding: 0 0;
    }
  }

}
</style>